import React from 'react';
import './testimonial.css'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";



const testiData = [
    {
        id:1,
        img: "images/testi.webp",
        name: "Romi RA",
        role: "Frontend Developer",
        message: "Bandung, nestled in West Java, Indonesia, captivates visitors with its enchanting blend of natural beauty and cultural richness."
    },
    {
        id:2,
        img: "images/testi1.webp",
        name: "Arisha Rumi",
        role: "UI/UX Design",
        message: "Exploring the wonders of Bandung, one is met with a tapestry of experiences that leave an indelible mark on the soul."
    },
    {
        id:3,
        img: "images/testi2.webp",
        name: "Muhammad Rijal",
        role: "Backend Developer",
        message: "Embarking on a journey to the enchanting Cukul Plantation in Bandung unveils a magical realm of beauty and tranquility."
    },
    {
      id:4,
      img: "images/testi3.webp",
      name: "Ririn Puspita",
      role: "Product Manager",
      message: "Cikole, a hidden gem nestled amidst the verdant landscapes of Bandung, invites nature enthusiasts to a haven of tranquility and adventure."
  },
  {
    id:5,
    img: "images/testi4.webp",
    name: "Muhammad Taufiq P",
    role: "DevOps",
    message: "Kawah Putih, the crown jewel of Bandung's natural wonders, beckons adventurers to a surreal realm of awe-inspiring beauty."
},
{
  id:6,
  img: "images/testi6.webp",
  name: "Kimi",
  role: "Digital Marketing",
  message: "The Great Asia Africa, located in the heart of Bandung, stands as a testament to the rich history and cultural diversity of the continent."
}
  ]

  
const Testimonial = () => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 750,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 590,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return (
    <section className="testimonial" id="testimonial">
        <article className="testimonial__data">
            <h1>What our customers are saying about us</h1>
        </article>

        <article className="cards__testimonial">
          <Slider {...settings} className='slider'>
            {
                testiData.map((item)=>{
                    const {id,img,name,role,message} = item;
                    return(
                  
                          <article className="card__article" key={id}>
                            <div className="card__image">
                              <img src={img} alt={name} className="card__img" />
                              <div className="card__shadow" />
                            </div>
                            <div className="card__data">
                              <h3 className="card__name">{name}</h3>
                              <p className='role__name'>{role}</p>
                              <p className="card__description">
                                {message}
                              </p>
                            </div>
                          </article>
         
                    )
                })
            }
          </Slider>
        </article>
    </section>
  )
}

export default Testimonial